document.addEventListener("DOMContentLoaded", () => {
  const cardLinks = document.querySelectorAll('.card-link')

  cardLinks.forEach(cl => {
    cl.addEventListener('click', function(e) {
      e.stopPropagation();
      location.href = cl.getAttribute('href')
    })
  })
})